/* eslint-disable import/prefer-default-export */

import { IEmptyState } from "app/interfaces/empty-state/empty-state.interface";
import { IInputModel } from "app/interfaces/input/input.interface";
import { ITextLabel } from "app/interfaces/text-label/textLabel.interface";
import ImagePath from "app/utilities/imagePath";

export const UserPortofolioFilterForm:IInputModel[] = [
	{
		id: 'inputUserPortofolioFilterName',
		formType: '',
		placeholder: 'Nama',
		name: 'name',
		apiErrorMessage: '',
		options: [],
		value: '',
	},
];

export const userPortofolioEmptyState: IEmptyState = {
	image: ImagePath.noData,
	placeholder: "Oops, saat ini belum ada User Portofolio yang tersedia",
	caption: "Portofolio Anda akan terdaftar di sini"
};

export const userPortofolioFilterEmptyState: IEmptyState = {
	image: ImagePath.noDataFilter,
	placeholder: "Oops, belum ada user portofolio yang sesuai filter",
	caption: "Coba reset atau ubah filter kamu, ya"
};

export const loadingTextLabelInit: ITextLabel[] = [
    {
        title: '',
        value: '',
        bg: false
    },
	{
        title: '',
        value: '',
        bg: false
    },
	{
        title: '',
        value: '',
        bg: false
    },
	{
        title: '',
        value: '',
        bg: false
    },
];
